<template>
    <v-text-field
        outlined
        dense
        clearable
        hide-details
        v-model.trim="rootSearch"
        prepend-inner-icon="$magnify"
        placeholder="Buscar"
        :name="fieldName"
        @keyup.enter="performSearch(true)"
        @click:clear="handleClear"
    ></v-text-field>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        search: {
            type: String,
            default: () => '',
        },
        routeParam: {
            required: false,
            default: null,
        },
        params: {
            type: Object,
            default: () => ({}),
        },
        fieldName: {
            type: String,
            default: 'search',
        },
    },
    data: () => ({
        rootSearch: '',
        debouncedSubmit: null,
        skipWatcher: false,
    }),
    created() {
        this.rootSearch = this.search ?? ''
        this.debouncedSubmit = _.debounce(() => {
            this.performSearch()
        }, 3000)
    },
    beforeDestroy() {
        this.debouncedSubmit?.cancel?.()
    },
    methods: {
        handleClear() {
            this.debouncedSubmit?.cancel?.()
            this.skipWatcher = true
            this.rootSearch = ''
            this.performSearch(true)
        },
        performSearch(immediate = false) {
            const next = this.rootSearch ?? ''
            const current = this.search ?? ''

            if (!immediate && next === current) {
                return
            }

            const base = this.routeParam
                ? this.route(this.currentRouteName, this.routeParam)
                : this.route(this.currentRouteName)
            const params = new URLSearchParams(this.params ?? {})

            if (next) {
                params.set('search', next)
                params.delete('clear_search')
            } else {
                params.delete('search')
                params.set('clear_search', 1)
            }

            const query = params.toString()
            const action = query ? `${base}?${query}` : base

            this.redirect(action)
        },
    },
    watch: {
        rootSearch(newValue, oldValue) {
            if (newValue === oldValue) {
                return
            }

            if (this.skipWatcher) {
                this.skipWatcher = false
                return
            }

            this.debouncedSubmit()
        },
        search(newValue) {
            const normalized = newValue ?? ''

            if (normalized !== this.rootSearch) {
                this.skipWatcher = true
                this.rootSearch = normalized
            }
        },
    },
}
</script>
